import React from "react";
import Slider from "react-slick";
import "../service.css"; // for custom glass effect

// Card Component with Glass Effect
const ServiceCard = ({ title, description, imageSrc, ctaText, ctaLink }) => {
  return (
    <div className="glass-card p-6 mx-4">
      {imageSrc && <img src={imageSrc} alt={title} className="card-image" />}
      <h3 className="card-title text-white text-lg sm:text-xl md:text-2xl font-semibold mt-4">{title}</h3>
      <p className="card-description text-white text-base mt-2 text-left">{description}</p>
      {/* CTA Button */}
      <a 
        href={ctaLink} 
        className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors duration-300 mt-4"
      >
        {ctaText}
      </a>
    </div>
  );
};

const OurApps = () => {
  // Sample card data - currently showing 2 cards
  const services = [
    { 
      title: "KSQ ProTrader Chart Suite", 
      description: "Convert your MetaTrader 5 terminal into a premium Trading Terminal. KSQ ProTrader embeds high-fidelity TradingView charts natively within your MT5 workspace. Chart, calculate contract-specific SL/TP values automatically in pips, and execute trades instantly via our sub-100ms trade bridge. Experience seamless broker symbol auto-synchronization and institutional execution speed in a single screen.",
      ctaText: "Learn More",
      ctaLink: "/tools/protrader-suite"
    },
    { 
      title: "HON-SONAR™ EA", 
      description: "HON-SONAR™ (Statistical Order-flow Network Analysis & Recognition) is a professional-grade Expert Advisor (EA) designed to detect and trade high-probability chart patterns with advanced algorithmic precision. Powered by Kalman filtering and multi-timeframe validation, it filters out market noise to deliver clean, reliable trading signals across forex, crypto, indices, and commodities. Whether you're a retail trader or managing institutional capital, HON-SONAR™ adapts in real-time to evolving market conditions, leveraging 13 core chart patterns, pattern consensus logic, and adaptive risk management.",
      ctaText: "Check it out",
      ctaLink: "/Hon-sonar"
    },
    { 
      title: "Trading Journal", 
      description: "The MT5 Trading Journal EA is a lightweight expert advisor that automatically logs your trades to a Google Sheets-based journal in real-time. It captures entries, exits, lot sizes, P/L, and risk metrics—then syncs everything via secure API to your custom spreadsheet. Ideal for serious traders who want automated trade tracking, risk analysis, and performance insights without manual data entry.",
      ctaText: "Learn More",
      ctaLink: "/journal"
    },
    // Add more services here when ready:
    { 
      title: "HON-Copier", 
      description: "AI-Powered Signal Automation That Never Sleeps Turn any Telegram signal into instant trades with revolutionary AI parsing technology. 95% accuracy, lightning-fast execution, bulletproof risk management. Stop missing signals. Start making profits. Automatically.",
      ctaText: "Learn More",
      ctaLink: "/honcopierpage"
    },
    { 
      title: "HON-VonScalper", 
      description: "Institutional-grade algorithmic scalping technology engineered for consistent performance across Forex, Crypto, and Synthetic Markets",
      ctaText: "Learn More",
      ctaLink: "/honvonscalper"
    },
  ];

  // Slider settings optimized for current card count
  const sliderSettings = {
    dots: services.length > 2, // Only show dots if more than 2 cards
    infinite: services.length > 2, // Only enable infinite scroll if more than 2 cards
    speed: 500,
    slidesToShow: Math.min(services.length, 2), // Show max 2 cards or available count
    slidesToScroll: 1,
    autoplay: services.length > 2, // Only autoplay if more than 2 cards
    autoplaySpeed: 20000,
    arrows: services.length > 2, // Only show arrows if more than 2 cards
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(services.length, 2),
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: services.length > 1,
          arrows: services.length > 1,
        }
      }
    ]
  };

  // Next and Prev Arrows for custom buttons
  function NextArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-blue-500 p-2 rounded-full cursor-pointer hover:bg-blue-700 z-10"
        onClick={onClick}
      >
        <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 18l6-6-6-6"></path>
        </svg>
      </div>
    );
  }

  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-blue-500 p-2 rounded-full cursor-pointer hover:bg-blue-700 z-10"
        onClick={onClick}
      >
        <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M14 18l-6-6 6-6"></path>
        </svg>
      </div>
    );
  }

  return (
    <section
      className="relative h-screen w-full flex justify-center items-center overflow-hidden"
      style={{ paddingTop: '80px' }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col justify-center items-center">
        <h1 className="text-2xl sm:text-3xl md:text-4xl text-white font-bold mb-6 sm:mb-8 px-4 text-center">Check Our Apps</h1>

        {/* Service Cards */}
        <div className="w-full max-w-6xl mx-auto relative">
          <Slider {...sliderSettings}>
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                title={service.title}
                description={service.description}
                imageSrc={service.imageSrc}
                ctaText={service.ctaText}
                ctaLink={service.ctaLink}
              />
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default OurApps;